import { AnswersByQuestionsModel } from "./AnswersByQuestionsModel";
import { ReviewersDetailsByRoleModel } from "./ReviewersDetailsByRoleModel";

export class ReviewStatusModel {
    reviewId: number;
    nextReviewDate: string;
    isCompleted: boolean;
    reviewers: ReviewersDetailsByRoleModel[];
    questionsAndResponses: AnswersByQuestionsModel[];
}